
export default function CompanyInfoSection() {
  return (
    <section id="company-info" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            運営組織について
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            安心してご利用いただけるよう、運営組織の詳細情報を公開しています
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <div className="bg-white rounded-2xl shadow-xl p-8">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">組織概要</h3>
              
              <div className="space-y-4">
                <div className="flex items-start">
                  <div className="w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center mr-3 mt-1">
                    <i className="ri-building-line text-blue-600 text-sm"></i>
                  </div>
                  <div>
                    <dt className="font-semibold text-gray-900">組織名</dt>
                    <dd className="text-gray-700">モニター友の会</dd>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center mr-3 mt-1">
                    <i className="ri-user-line text-blue-600 text-sm"></i>
                  </div>
                  <div>
                    <dt className="font-semibold text-gray-900">代表者</dt>
                    <dd className="text-gray-700">陸村　美紗央</dd>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center mr-3 mt-1">
                    <i className="ri-map-pin-line text-blue-600 text-sm"></i>
                  </div>
                  <div>
                    <dt className="font-semibold text-gray-900">所在地</dt>
                    <dd className="text-gray-700">
                      〒450-0002<br />
                      愛知県名古屋市中村区名駅3-4-10
                    </dd>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center mr-3 mt-1">
                    <i className="ri-phone-line text-blue-600 text-sm"></i>
                  </div>
                  <div>
                    <dt className="font-semibold text-gray-900">電話番号</dt>
                    <dd className="text-gray-700">052-562-9521</dd>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center mr-3 mt-1">
                    <i className="ri-mail-line text-blue-600 text-sm"></i>
                  </div>
                  <div>
                    <dt className="font-semibold text-gray-900">メール</dt>
                    <dd className="text-gray-700">support-sp@review-union.com</dd>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center mr-3 mt-1">
                    <i className="ri-calendar-line text-blue-600 text-sm"></i>
                  </div>
                  <div>
                    <dt className="font-semibold text-gray-900">設立</dt>
                    <dd className="text-gray-700">2018年4月</dd>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center mr-3 mt-1">
                    <i className="ri-briefcase-line text-blue-600 text-sm"></i>
                  </div>
                  <div>
                    <dt className="font-semibold text-gray-900">事業内容</dt>
                    <dd className="text-gray-700">
                      商品レビュー支援サービス<br />
                      商品モニター募集・管理<br />
                      マーケティング支援
                    </dd>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="space-y-8">
            <div className="bg-white rounded-2xl shadow-xl p-8">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">私たちの使命</h3>
              <p className="text-gray-700 leading-relaxed mb-4">
                モニター友の会は、消費者と企業をつなぐ架け橋として、より良い商品開発と消費者満足度の向上に貢献しています。
              </p>
              <p className="text-gray-700 leading-relaxed">
                私たちは透明性と信頼性を最重要視し、すべてのモニター様に安心してご参加いただける環境を提供しています。
              </p>
            </div>

            <div className="bg-white rounded-2xl shadow-xl p-8">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">実績・信頼性</h3>
              <div className="grid grid-cols-2 gap-4">
                <div className="text-center p-4 bg-blue-50 rounded-lg">
                  <div className="text-2xl font-bold text-blue-600 mb-1">2,200+</div>
                  <div className="text-sm text-gray-600">登録モニター数</div>
                </div>
                <div className="text-center p-4 bg-blue-50 rounded-lg">
                  <div className="text-2xl font-bold text-blue-600 mb-1">270+</div>
                  <div className="text-sm text-gray-600">提携企業数</div>
                </div>
                <div className="text-center p-4 bg-blue-50 rounded-lg">
                  <div className="text-2xl font-bold text-blue-600 mb-1">7年</div>
                  <div className="text-sm text-gray-600">運営実績</div>
                </div>
                <div className="text-center p-4 bg-blue-50 rounded-lg">
                  <div className="text-2xl font-bold text-blue-600 mb-1">93%</div>
                  <div className="text-sm text-gray-600">顧客満足度<br />リピート依頼率</div>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-2xl shadow-xl p-8">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">認証・許可</h3>
              <div className="space-y-3">
                <div className="flex items-center">
                  <i className="ri-shield-check-line text-green-600 mr-3"></i>
                  <span className="text-gray-700">プライバシーマーク取得準備中</span>
                </div>
                <div className="flex items-center">
                  <i className="ri-shield-check-line text-green-600 mr-3"></i>
                  <span className="text-gray-700">特定商取引法に基づく表記完備</span>
                </div>
                <div className="flex items-center">
                  <i className="ri-shield-check-line text-green-600 mr-3"></i>
                  <span className="text-gray-700">個人情報保護法遵守</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-16 bg-blue-600 rounded-2xl p-8 text-white text-center">
          <h3 className="text-2xl font-bold mb-4">お問い合わせ</h3>
          <p className="mb-6">
            ご質問やご不明な点がございましたら、お気軽にお問い合わせください
          </p>
          <div className="flex flex-col md:flex-row justify-center items-center space-y-4 md:space-y-0 md:space-x-8">
            <div className="flex items-center">
              <i className="ri-phone-line mr-2"></i>
              <span>052-562-9521</span>
            </div>
            <div className="flex items-center">
              <i className="ri-mail-line mr-2"></i>
              <span>support-sp@review-union.com</span>
            </div>
            <div className="flex items-center">
              <i className="ri-time-line mr-2"></i>
              <span>平日 10:00-18:00</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
